import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.58 23.58"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#fff" }, [
      _createElementVNode("path", { d: "M11.79 23.58C5.29 23.58 0 18.29 0 11.79S5.29 0 11.79 0s11.79 5.29 11.79 11.79-5.29 11.79-11.79 11.79Zm0-22.69C5.78.89.89 5.78.89 11.79s4.89 10.9 10.9 10.9 10.9-4.89 10.9-10.89S17.8.89 11.79.89Z" }),
      _createElementVNode("path", { d: "M17.36 5.61c-.63.73-1.25 1.46-1.88 2.19-.77.9-1.54 1.79-2.32 2.69-.02.03-.04.05-.07.09 1.54 2.25 3.09 4.49 4.64 6.75H14.41c-.08 0-.11-.03-.16-.09-.99-1.45-1.99-2.9-2.99-4.35-.03-.04-.05-.07-.08-.12-.29.34-.58.67-.86 1l-3 3.48c-.03.04-.1.07-.15.07h-.92c1.5-1.75 2.99-3.47 4.48-5.21-.02-.03-.04-.07-.06-.1-1.44-2.1-2.88-4.2-4.32-6.29a.638.638 0 0 1-.08-.14h3.41c0 .02.02.03.03.05l2.88 4.2c.01.02.03.04.04.07 1.25-1.46 2.48-2.89 3.72-4.32h1.01Zm-1.02 11.01s-.05-.08-.07-.1c-2.34-3.35-4.69-6.7-7.03-10.06-.04-.06-.09-.08-.16-.08H7.63c.04.05.06.09.09.13 1.66 2.37 3.31 4.74 4.97 7.11.68.97 1.35 1.94 2.03 2.91.03.04.08.08.12.08h1.49Z" })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "Twitter_X"}) } }